module.exports = __webpack_public_path__ + "img/keranjang.423133a6.svg";